import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import Config from '../../Util/config';
import HttpUtil from '../../Util/httpUtil';

const dominioAPICont = Config.urls.API_URL_CONT;
const dominioAPIFiscal = Config.urls.API_URL_FISCAL;

class CheckBoxRevisado extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            classCheckBox: this.props.row.CORRIGIDO == 'S' ?
                "ecoico ecoico-ok pr-2" :
                "ecoico ecoico-off pr-2",
            textoCheckBox: this.props.row.CORRIGIDO == 'S' ? "Sim" : "",
            status: this.props.row.CORRIGIDO
        };
    }

    onClickCheckBox = (row, isChecked, event) => {
        event.preventDefault();

        this.requestData(row, isChecked).then(res => {
            if (res) {
                this.setState({
                    classCheckBox: this.state.status == 'S' ?
                        "ecoico ecoico-off pr-2" :
                        "ecoico ecoico-ok pr-2",
                    textoCheckBox: this.state.status == 'S' ? "Não" : "Sim",
                    status: this.state.status == 'S' ? 'N' : 'S'
                });
            }
        });
    }

    requestData = (row, isChecked) => {
        return new Promise((resolve, reject) => {

            let data = new FormData();
            data.append('REGISTRO', row.REGISTRO);
            data.append('LINHA', row.LINHA);
            data.append('CAMPO', row.CAMPO);
            data.append('OCORRENCIA', row.OCORRENCIA);
            data.append('ID_ARQUIVO', this.props.id_arquivo);
            data.append('CORRIGIDO', isChecked ? 'N' : 'S');
            data.append('ESTADO', 'S');

            let urlApi =
                this.props.moduloEfd === "Fiscal" ? Config.urls.API_URL_FISCAL
                : this.props.moduloEfd === "ECF" ? Config.urls.API_URL_ECF
                : this.props.moduloEfd === "ECD" ? Config.urls.API_URL_ECD
                : Config.urls.API_URL_CONT;

            HttpUtil.eco_POST(`${urlApi}Validacao/SetarCheck`, data, (response) => {
                resolve({ resposta: response.data });
            }, () => { console.log("Error ExibirErrosEstrutura"); });
        });
    };

    render() {
        return (
            <Row>
                <Col>
                    <a href="#" onClick={this.onClickCheckBox.bind(this, this.props.row, this.state.status == 'S')} className="itemRevisado">
                        <i className={this.state.classCheckBox} />
                        <span>{this.state.textoCheckBox}</span>
                    </a>
                </Col>
            </Row>
        );
    }
}

export default CheckBoxRevisado;


// WEBPACK FOOTER //
// ./src/Componente/Resultado/CheckBoxRevisado.jsx